import React from 'react'
import Header from '../components/common/Header'
import Banner from '../components/common/Banner'
import ServiceList from '../views/dev/ServiceList';
import ProjectsSection from '../views/landing/ProjectsSection';
import { ux_ServiceItems } from '../constants/servicesItems';
import FaqSection from '../views/landing/FaqSection';
import {uiuxFaqs} from '../constants/uiuxFaqs';
import { Helmet } from 'react-helmet-async';
interface Props { }

const Ux = (props: Props) => {
    const { } = props

    return (
      <>
        <Helmet>
          <title>App Design Services in LA | UI/UX Agency in Los Angeles, USA</title>
          <meta
            name="description"
            content="Atini Studio provides exceptional website design services in LA, combining expert user interface design with app design services to create a flawless user journey."
          />
            <link rel="alternate" hrefLang="en-US" href="https://atinistudio.com/ui-ux" />
            <link rel="canonical" href="https://atinistudio.com/ui-ux" />
        </Helmet>
        <Header
          pillLabel="UI/UX Design"
          title="Elevate Every Interaction with Inspired Design"
          description="Our innovative and skilled designers merge creativity and functionality to craft visually stunning user interfaces, setting unique trends as a leading UI/UX agency in Los Angeles."
          renderButton
          buttonText="Check My Software"
          image="ux_header.svg"
          altTag="UI/UX Agency in Los Angeles "
        />
        <Banner
          pillLabel="Services We Offer"
          title="Explore Our Services to Kickstart Your Journey"
          description="Ensuring your product is visually impressive while engaging and delighting users. We bring your vision to life with our User Interface Design services, creating an aesthetically pleasing and user-friendly experience that paves the way for unparalleled digital interactions."
        />
        <ServiceList items={ux_ServiceItems} />
        <ProjectsSection />
        <FaqSection questionAnswerArray={uiuxFaqs} />
      </>
    );
}
export default Ux